import React, {useEffect, useState} from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { apiCallBegan } from '../store/api'
import { FaRegCalendarAlt } from '@react-icons/all-files/fa/FaRegCalendarAlt'
import B2BIndex from './B2BIndex';
import { refreshURL } from '../store/slices/cache'
import { getUser } from '../store/slices/user';

const PreferredPartnership = ({potential, setStep, onContinue}) => {
    let dispatch = useDispatch()
    let [selected, setSelected] = useState({})
    let {user} = useSelector(getUser)

    useEffect(() => {
        if(potential?.model) {
            setSelected(potential?.model )
        }
    }, [potential])

    let submit = data => {
        dispatch(apiCallBegan({ url: `/business/edits/${potential?._id}`, method: 'PUT', data: {model: selected} , showSpinner: true, onExtFunc: () => {
            if(onContinue) {
                onContinue()
            } else {
                setStep(potential?.main_contact?.user? selected?.two? 3 : 4 :2)   
                dispatch(refreshURL(`/business/withContacts/${potential?._id}`))
            }

         

        } }))
    }

    return <div className="PreferredPartnership partnerships" >
    <B2BIndex one={true} two={true} three={true} four={true} choose={submit} selected={selected} setSelected={setSelected} />


    </div>
}

export default PreferredPartnership